
// OJ 
export const BASE_API = "https://45811.acmcoder.com"
export const CDN_URL = "https://cdnw2.acmcoder.com/release/www/version/static"

// C 
export const REPORT_API = "https://report1014.acmcoder.com"

export const LOGIN_API = "https://62885.acmcoder.com"


// WEBPACK FOOTER //
// ./src/api.js